<template lang="pug">
	modal(:max-width="500", v-if="recibo")
		.card.text-left
			.card-header.bg-danger.text-white
				span.fa.fa-money.mr-2
				| Recibo
				button.close(@click="cerrar") &times;
			.alert.alert-danger.m-0(v-if="recibo.Estado === 'Pendiente'")
				span.fa.fa-exclamation-triangle.mr-2
				| Este recibo está pendiente
			.alert.alert-success.m-0(v-else)
				span.fa.fa-check.mr-2
				| Este recibo está pagado
			.card-body.bg-light
				div
					b
						span.fa.fa-building.mr-2
						| Empresa
					.input-group.mt-1
						select.form-control(v-model="recibo.EmpresaID", :disabled="reciboContrato")
							option(:value="null") Selecciona
							option(
								v-for="empresa in listadoEmpresas"
								:key="empresa.ID_empresa"
								:value="empresa.ID_empresa"
							) {{empresa.nombreFiscal}}
				div.mt-2
					b
						span.fa.fa-building.mr-2
						| Cliente
					.input-group.mt-1
						input.form-control(v-if="recibo.ClienteID", :value="recibo.ClienteNombre", disabled)
						input-query(
							v-if="!reciboContrato && !recibo.ClienteID"
							:realtime="true"
							url="/facturacion-cobros/php/api/query-clientes.php"
							@selected="seleccionaCliente($event)"
							input-class="form-control"
							placeholder="Busca y selecciona un cliente"
						)
						.input-group-append(v-if="!reciboContrato && recibo.ClienteID")
							button.btn.btn-danger(@click="quitarCliente")
								span.fa.fa-trash

				div.mt-2
					b
						span.fa.fa-user.mr-2
						| Agente
					.input-group.mt-1
						input.form-control(v-if="recibo.AgenteID", :value="recibo.AgenteNombre", disabled)
						input-query(
							v-if="!reciboContrato && !recibo.AgenteID"
							:realtime="true"
							url="/facturacion-cobros/php/api/query-agentes.php"
							@selected="seleccionaAgente($event)"
							input-class="form-control"
							placeholder="Busca y selecciona un agente"
						)
						.input-group-append(v-if="!reciboContrato && recibo.AgenteID")
							button.btn.btn-danger(@click="quitarAgente")
								span.fa.fa-trash
						.input-group-append.input-group-prepend
							.input-group-text Comisión
						input.form-control(v-model="recibo.ComisionAgente", :disabled="recibo.Estado !== 'Pendiente'")
						.input-group-append
							.input-group-text %

			// Ahora las fechas de vencimiento
			.card-body
				h4
					b
						span.fa.fa-money-mr-2
						| Detalles del recibo
				div.row.mt-2.mb-2.text-dark.text-center.bg-light.pt-3.pb-3(style="border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;box-shadow:0 2px 5px rgba(0,0,0,0.07);")
					.col
						| Fecha de vencimiento
						br
						b {{recibo.FechaVencimiento | moment('DD-MM-YYYY')}}
					.col
						| Fecha de cobro
						br
						b {{recibo.FechaPagado || new Date() | moment('DD-MM-YYYY')}}
					.col(v-if="recibo.Estado === 'Pendiente' && recibo.ContratoID")
						| Importe del recibo
						br
						div(style="cursor:pointer;font-weight:bolder;", @click="asignaImporteDefinido")
							| {{recibo.ImporteTotal | currency('')}} €
							button.btn.btn-sm.btn-primary.ml-3(style="width:15px;height:15px;line-height:0;text-align:center;padding: 0;")
								span.fa.fa-caret-down
				div.mt-4
					.form-group
						label
							b Importe pagado
						.input-group
							input.form-control(
								v-if="recibo.Estado === 'Pendiente'"
								ref="importe",
								style="font-size:3em;text-align:right;",
								:disabled="recibo.Estado === 'Pagado'",
								placeholder="0",
								v-model.number="recibo.ImportePagadoRecibo"
							)
							input.form-control(
								v-else
								ref="importe",
								style="font-size:3em;text-align:right;",
								:disabled="true",
								placeholder="0",
								:value="recibo.ImporteTotal | currency('') + ' €'"
							)
							.input-group-append
								.input-group-text(style="font-size:3em;")
									| €
					.alert.alert-warning.mt-3.mb-3(v-if="recibo.ReciboID !== recibo.PrimerReciboSinPagar && recibo.Estado === 'Pendiente' && recibo.ContratoID")
						span.fa.fa-info-circle.mr-2
						| Este no es el primer recibo del contrato pendiente de pago. Al pulsar sobre el botón de "Cobrar", el sistema primero saldará el importe de los recibos pendientes anteriores a este.
				div.mt-2(v-if="recibo.Estado === 'Pendiente' && recibo.ContratoID")
					.form-group
						label
							b Importe pendiente del contrato
						.input-group
							input.form-control(style="font-size:3em;text-align:right;", disabled, :value="round(recibo.ContratoImporteTotal - recibo.ImportePagadoContrato - recibo.ImportePagadoRecibo)")
							.input-group-append
								.input-group-text(style="font-size:3em;")
									| €
				div.mt-2(v-if="recibo.Estado === 'Pendiente'")
					.form-group
						label
							b Forma de pago
						select.form-control(v-model="recibo.FormaDePagoID")
							option(:value="null") Selecciona
							option(v-for="forma in listadoFormasDePago", :value="forma.ID_forma_de_pago", :key="forma.ID_forma_de_pago") {{forma.nombre}}
				div.mt-2(v-if="recibo.Estado === 'Pendiente' && necesarioIBAN")
					.form-group
						label
							b IBAN
						input.form-control(placeholder="IBAN", v-model="recibo.IBAN")

			.card-footer
				button.mr-2.btn.btn-primary(v-if="recibo.Estado === 'Pagado'")
					span.fa.fa-download.mr-2
					| Descargar recibo
				button.mr-2.btn.btn-danger(v-if="recibo.Estado === 'Pendiente'", @click="cobrar")
					span.fa.fa-money.mr-2
					| Cobrar


</template>


<script>
import API from '../../services/api'
import { mapGetters } from 'vuex'
export default {
	props: ['idRecibo'],
	data () {
		return {
			recibo: null,
			listadoFormasDePago: [],
			listadoEmpresas: [],
			comisionAgente: null
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		}),
		reciboContrato () {
			if (this.idRecibo === 'nuevo' || !this.recibo) {
				return false
			}

			return (this.recibo.ContratoID)
		},
		necesarioIBAN () {
			if (this.recibo && this.recibo.FormaDePagoID) {
				for (let i = 0; i < this.listadoFormasDePago.length; i++) {
					const f = this.listadoFormasDePago[i]
					if (f.ID_forma_de_pago === this.recibo.FormaDePagoID) {
						return f.requiere_iban
					}
				}
			}
			return false
		},
		valido () {
			if (!this.recibo.AgenteID) {
				return {
					resultado: false,
					error: 'No hay un agente asociado'
				}
			}

			if (!this.recibo.ImportePagadoRecibo) {
				return {
					resultado: false,
					error: 'Debes escribir un importe a cobrar'
				}
			}

			if (!this.recibo.FormaDePagoID) {
				return {
					resultado: false,
					error: 'Debes definir la forma de pago'
				}
			}

			if (this.necesarioIBAN && !this.recibo.IBAN) {
				return {
					resultado: false,
					error: 'Debes escribir el IBAN'
				}
			}

			return {
				resultado: true
			}
		}
	},
	created () {
		API.getFormasDePago()
			.then(res => {
				this.listadoFormasDePago = res.data.formas
			})
			.catch(e => {
				this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error obteniendo las formas de pago'
				})
			})
		API.getEmpresas()
			.then(res => {
				this.listadoEmpresas = res.data
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
		if (this.idRecibo && this.idRecibo !== 'nuevo') {
			API.get(this.idRecibo)
				.then(res => {
					res.data.ImportePagadoRecibo = (res.data.ContratoID && res.data.Estado === 'Pendiente') ? null : res.data.ImporteRecibo
					this.recibo = res.data
					this.verEditor = true

					// Cargamos la comisión del agente
					if (this.recibo.AgenteID) {
						API.getComisionAgente(this.recibo.AgenteID)
							.then(res => {
								this.comisionAgente = res.data.comision
								console.log('Tenemos la comisión')
								if (this.recibo.ComisionAgente === null && this.recibo.Estado === 'Pendiente') {
									console.log('Asignamos la comisión')
									this.recibo.ComisionAgente = this.comisionAgente + 0
								}
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		} else if (this.idRecibo === 'nuevo') {
			this.recibo = {
				ReciboID: null,
				ClienteID: null,
				ClienteNombre: null,
				AgenteID: null,
				AgenteNombre: null,
				UsuarioID: this.usuario.ID.toString(),
				UsuarioNombre: this.usuario.nombre + ' ' + this.usuario.apellidos,
				FechaVencimiento: new Date(),
				FechaPago: new Date(),
				Estado: 'Pendiente',
				FormaDePagoID: null,
				ImporteTotal: null,
				ContratoID: null,
				ComisionAgente: null
			}
		}
	},
	mounted () {
		window.setTimeout(() => {
			if (this.$refs.importe) {
				this.$refs.importe.focus()
			}
		}, 300)
	},
	methods: {
		seleccionaCliente (ev) {
			this.recibo.ClienteID = ev.datos.ID
			this.recibo.ClienteNombre = ev.datos.cliente
		},
		quitarCliente () {
			this.recibo.ClienteID = null
			this.recibo.ClienteNombre = null
		},
		seleccionaAgente (ev) {
			this.recibo.AgenteID = ev.datos.ID
			this.recibo.AgenteNombre = ev.datos.nombre + ' ' + ev.datos.apellidos

			API.getComisionAgente(this.recibo.AgenteID)
				.then(res => {
					this.comisionAgente = res.data.comision
					console.log('Tenemos la comisión')
					if (this.recibo.ComisionAgente === null && this.recibo.Estado === 'Pendiente') {
						console.log('Asignamos la comisión')
						this.recibo.ComisionAgente = this.comisionAgente + 0
					}
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		quitarAgente () {
			this.recibo.AgenteID = null
			this.recibo.AgenteNombre = null
		},
		asignaImporteDefinido () {
			this.recibo.ImportePagadoRecibo = this.recibo.ImporteTotal * 1
		},
		cobrar () {
			if (this.valido.resultado === false) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: this.valido.error
				})
				return
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Pagar recibo',
				mensaje: `<div class="text-center">Estas a punto de registrar el pago de
				<h3>${this.recibo.ImportePagadoRecibo} €</h3>
				en este contrato.
				¿Quieres continuar?</div>`,
				callback: acepta => {
					if (acepta) {
						API.pagarRecibo(this.recibo)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Recibo pagado',
									mensaje: 'Se ha pagado el recibo correctamente'
								})
								this.$emit('actualizar')
								this.$emit('cerrar')
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/cobros/editor-nuevo.vue